import { render, staticRenderFns } from "./defaultrate.vue?vue&type=template&id=bfe616fa&scoped=true&"
import script from "./defaultrate.vue?vue&type=script&lang=js&"
export * from "./defaultrate.vue?vue&type=script&lang=js&"
import style0 from "./defaultrate.vue?vue&type=style&index=0&id=bfe616fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe616fa",
  null
  
)

export default component.exports